/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `is` - IS
 * * `is not` - IS_NOT
 * * `is not set` - IS_NOT_SET
 * * `include` - INCLUDE
 * * `don't include` - DO_NOT_INCLUDE
 * * `are not set` - ARE_NOT_SET
 * * `exists` - EXISTS
 * * `exist` - EXIST
 * * `contains` - CONTAINS
 * * `contain` - CONTAIN
 * * `is before` - IS_BEFORE
 * * `is after` - IS_AFTER
 * * `is between` - IS_BETWEEN
 * * `is checked` - IS_CHECKED
 * * `is unchecked` - IS_UNCHECKED
 * * `=` - EQUAL
 * * `≠` - NOT_EQUAL
 * * `<` - LESS_THAN
 * * `>` - GREATER_THAN
 * * `≤` - LESS_THAN_OR_EQUAL
 * * `≥` - GREATER_THAN_OR_EQUAL
 */
export enum FilterApplicability {
  IS = 'is',
  IS_NOT = 'is not',
  IS_NOT_SET = 'is not set',
  INCLUDE = 'include',
  DO_NOT_INCLUDE = 'don\'t include',
  ARE_NOT_SET = 'are not set',
  EXISTS = 'exists',
  EXIST = 'exist',
  CONTAINS = 'contains',
  CONTAIN = 'contain',
  IS_BEFORE = 'is before',
  IS_AFTER = 'is after',
  IS_BETWEEN = 'is between',
  IS_CHECKED = 'is checked',
  IS_UNCHECKED = 'is unchecked',
  EQUAL = '=',
  NOT_EQUAL = '≠',
  LESS_THAN = '<',
  GREATER_THAN = '>',
  LESS_THAN_OR_EQUAL = '≤',
  GREATER_THAN_OR_EQUAL = '≥',
}
